import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import {
//   AwarenessListPage,
//   AwarenessFormPage,
//   AwarenessSectionsPage,
// } from './pages/Writer/Awareness';
import AwarenessListPage from './pages/Writer/Awareness/AwarenessListPage';
import AwarenessFormPage from './pages/Writer/Awareness/AwarenessFormPage';
import AwarenessSectionsPage from './pages/Writer/Awareness/AwarenessSectionsPage';
import AwarenessViewPage from './pages/Writer/Awareness/AwarenessViewPage';
import MainLayout from './layouts/MainLayout';
import DashboardPage from './pages/MasterAdmin/DashboardPage';
import VendorsPage from './pages/MasterAdmin/VendorsPage';
import UsersPage from './pages/MasterAdmin/UsersPage';
import UserAnalyticsPage from './pages/MasterAdmin/UserAnalyticsPage';
import SessionDetailPage from './pages/MasterAdmin/SessionDetailPage';
import ReportsPage from './pages/MasterAdmin/ReportsPage';
import MonitoringPage from './pages/MasterAdmin/MonitoringPage';
import OperationsDashboardPage from './pages/MasterAdmin/OperationsDashboardPage';
import AppTrackingInsightsPage from './pages/MasterAdmin/AppTrackingInsightsPage';
import DailyAnalyticsDashboardPage from './pages/MasterAdmin/DailyAnalyticsDashboardPage';
import ChatbotIntelligencePage from './pages/MasterAdmin/ChatbotIntelligencePage';
import LoginPage from './pages/MasterAdmin/LoginPage';
import HospitalVendorDashboard from './pages/MasterAdmin/vendor-dashboards/HospitalVendorDashboard';
import AmbulanceVendorDashboard from './pages/MasterAdmin/vendor-dashboards/AmbulanceVendorDashboard';
import AmbulanceBookingDetailPage from './pages/MasterAdmin/vendor-dashboards/AmbulanceBookingDetailPage';
import AmbulanceVendorDetailsPage from './pages/MasterAdmin/vendor-dashboards/AmbulanceVendorDetailsPage';
import AmbulanceVendorPricingPage from './pages/MasterAdmin/vendor-dashboards/AmbulanceVendorPricingPage';
import AmbulanceVendorServiceAreasPage from './pages/MasterAdmin/vendor-dashboards/AmbulanceVendorServiceAreasPage';
import AmbulanceVendorFleetPage from './pages/MasterAdmin/vendor-dashboards/AmbulanceVendorFleetPage';
import MedicalStoreVendorDashboard from './pages/MasterAdmin/vendor-dashboards/MedicalStoreVendorDashboard';
import MedicalStoreVendorDetailsPage from './pages/MasterAdmin/vendor-dashboards/MedicalStoreVendorDetailsPage';
import MedicalStoreMedicineOrderDetailPage from './pages/MasterAdmin/vendor-dashboards/MedicalStoreMedicineOrderDetailPage';
import BloodBankVendorDashboard from './pages/MasterAdmin/vendor-dashboards/BloodBankVendorDashboard';
import DoctorClinicVendorDashboard from './pages/MasterAdmin/vendor-dashboards/DoctorClinicVendorDashboard';
import DoctorClinicVendorDetailsPage from './pages/MasterAdmin/vendor-dashboards/DoctorClinicVendorDetailsPage';
import DoctorClinicVendorTimeslotsPage from './pages/MasterAdmin/vendor-dashboards/DoctorClinicVendorTimeslotsPage';
import DiagnosticCenterVendorDashboard from './pages/MasterAdmin/vendor-dashboards/DiagnosticCenterVendorDashboard';
import ProductVendorDashboard from './pages/MasterAdmin/vendor-dashboards/ProductVendorDashboard';
import VendorLoginActivityPage from './pages/MasterAdmin/vendor-dashboards/VendorLoginActivityPage';
import VendorEventTimelinePage from './pages/MasterAdmin/vendor-dashboards/VendorEventTimelinePage';
import EmployeesPage from './pages/MasterAdmin/EmployeesPage';
import TeamMemberAccessPage from './pages/MasterAdmin/TeamMemberAccessPage';
import SalesExecutiveLayout from './components/SalesExecutive/SalesExecutiveLayout';
import SalesExecutiveDashboardPage from './pages/SalesExecutive/SalesExecutiveDashboardPage';
import SalesExecutiveVendorOnboardingPage from './pages/SalesExecutive/SalesExecutiveVendorOnboardingPage';
import SalesExecutiveAddVendorPage from './pages/SalesExecutive/SalesExecutiveAddVendorPage';
import SalesExecutiveDashboard from './pages/MasterAdmin/employee-dashboard/SalesExecutiveDashboard';
import AddHospitalVendorForm from './pages/SalesExecutive/VendorForms/AddHospitalVendorForm';
import AmbulanceVendorForm from './pages/SalesExecutive/VendorForms/AmbulanceVendorForm';
import DoctorClinicVendorForm from './pages/SalesExecutive/VendorForms/DoctorClinicVendorForm';
import MedicalStoreVendorForm from './pages/SalesExecutive/VendorForms/MedicalStoreVendorForm';
import BloodBankVendorForm from './pages/SalesExecutive/VendorForms/BloodBankVendorForm';
import DiagnosticCenterVendorForm from './pages/SalesExecutive/VendorForms/DiagnosticCenterVendorForm';
import ProductPartnerVendorForm from './pages/SalesExecutive/VendorForms/ProductPartnerVendorForm';

import { ThemeProvider } from './hooks/useTheme';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/MasterAdmin/ProtectedRoute';
import { MantineProvider } from '@mantine/core';
import { Toaster } from 'react-hot-toast';
import AccountantLayout from './layouts/AccountantLayout';
import AccountantDashboardPage from './pages/Accountant/AccountantDashboardPage';
import VendorSettlementsPage from './pages/Accountant/VendorSettlementsPage';
import VendorLedgerDetailsPage from './pages/Accountant/VendorLedgerDetailsPage';
import LedgerPage from './pages/Accountant/LedgerPage';
import AccountantReportsPage from './pages/Accountant/ReportsPage';
import AuditLogsPage from './pages/Accountant/AuditLogsPage';
import OrderLedgerPage from './pages/Accountant/OrderLedgerPage';
import CustomerLedgerPage from './pages/Accountant/CustomerLedgerPage';
import VendorLedgerPage from './pages/Accountant/VendorLedgerPage';
import VendorLedgerMedicinePage from './pages/Accountant/VendorLedgerMedicinePage';
import VendorLedgerAmbulancePage from './pages/Accountant/VendorLedgerAmbulancePage';
import VendorLedgerDoctorPage from './pages/Accountant/VendorLedgerDoctorPage';
import DeliveryPartnerLedgerPage from './pages/Accountant/DeliveryPartnerLedgerPage';
import RazorpayLedgerPage from './pages/Accountant/RazorpayLedgerPage';
import BankAccountLedgerPage from './pages/Accountant/BankAccountLedgerPage';
import CommissionLedgerPage from './pages/Accountant/CommissionLedgerPage';
import ProfitLossLedgerPage from './pages/Accountant/ProfitLossLedgerPage';
import GSTLedgerPage from './pages/Accountant/GSTLedgerPage';
import BorzoDeliveriesPage from './pages/MasterAdmin/BorzoDeliveriesPage';
import InProgressNotifyPage from './pages/MasterAdmin/InProgressNotifyPage';
import AmbulanceOffHoursAnalyticsPage from './pages/MasterAdmin/AmbulanceOffHoursAnalyticsPage';
import AmbulanceServiceAreaComparePage from './pages/MasterAdmin/AmbulanceServiceAreaComparePage';
import CommunicationsHubPage from './pages/Communications/CommunicationsHubPage';
import LegacyCommunicationsRedirect from './components/Communications/LegacyCommunicationsRedirect';
import FeedbacksPage from './pages/MasterAdmin/FeedbacksPage';
import GrievancesPage from './pages/MasterAdmin/GrievancesPage';
import GrievanceResolvePage from './pages/MasterAdmin/GrievanceResolvePage';
import VendorReferenceDataPage from './pages/MasterAdmin/VendorReferenceDataPage';
import VendorProfileUpdatesPage from './pages/MasterAdmin/VendorProfileUpdatesPage';
import InstantConsultationSpecialitiesPage from './pages/MasterAdmin/InstantConsultationSpecialitiesPage';
import SymptomSpecialityMappingsPage from './pages/MasterAdmin/SymptomSpecialityMappingsPage';
import {
  GrievanceUserPolicyPage,
  GrievanceVendorPolicyPage,
} from './pages/MasterAdmin/GrievancePolicyPage';
import HealthRecordUsagePage from './pages/MasterAdmin/HealthRecordUsagePage';
import VendorStoragePage from './pages/MasterAdmin/VendorStoragePage';
import AppVersionControlPage from './pages/MasterAdmin/AppVersionControlPage';
import SupportFaqsPage from './pages/MasterAdmin/SupportFaqsPage';
import AppUpdateNotificationHistoryPage from './pages/MasterAdmin/AppUpdateNotificationHistoryPage';
import PrescriptionQueuePage from './pages/MasterAdmin/PrescriptionQueuePage';
import MasterAdminAmbulanceBookingsPage from './pages/MasterAdmin/MasterAdminAmbulanceBookingsPage';
import AmbulanceQueueTrackingPage from './pages/MasterAdmin/AmbulanceQueueTrackingPage';
import PushNotificationsPage from './pages/MasterAdmin/PushNotificationsPage';
import MarketingLayout from './layouts/MarketingLayout';
import MarketingDashboardPage from './pages/Marketing/MarketingDashboardPage';
import MarketingEmailsPage from './pages/Marketing/MarketingEmailsPage';
import WhatsAppHubPage from './pages/Marketing/WhatsAppHubPage';
import NotificationsPage from './pages/MasterAdmin/NotificationsPage';
import VendorCommissionManagementPage from './pages/MasterAdmin/VendorCommissionManagementPage';
import BookingOffersPage from './pages/MasterAdmin/BookingOffersPage';
import MembershipManagementPage from './pages/MasterAdmin/MembershipManagementPage';
import DeepLinksManagementPage from './pages/MasterAdmin/DeepLinksManagementPage';
import MediaManagementPage from './pages/MasterAdmin/MediaManagementPage';
import VendorPolicyQueriesPage from './pages/MasterAdmin/VendorPolicyQueriesPage';
import VendorContactQueriesPage from './pages/MasterAdmin/VendorContactQueriesPage';
import LegalPoliciesManagementPage from './pages/MasterAdmin/LegalPoliciesManagementPage';
import LegalPolicyCreatePage from './pages/MasterAdmin/LegalPolicyCreatePage';
import LegalPolicyEditPage from './pages/MasterAdmin/LegalPolicyEditPage';
import LegalPolicyAcceptancesPage from './pages/MasterAdmin/LegalPolicyAcceptancesPage';
import VendorManualRefundCasesPage from './pages/MasterAdmin/VendorManualRefundCasesPage';
import MaOrderLedgerPage from './pages/MasterAdmin/MaOrderLedgerPage';
import BillingOverviewPage from './pages/MasterAdmin/BillingAnalytics/BillingOverviewPage';
import BillingServicesPage from './pages/MasterAdmin/BillingAnalytics/BillingServicesPage';
import BillingResourcesPage from './pages/MasterAdmin/BillingAnalytics/BillingResourcesPage';
import BillingHistoryPage from './pages/MasterAdmin/BillingAnalytics/BillingHistoryPage';
import WriterLayout from './layouts/WriterLayout';
import WriterDashboardPage from './pages/Writer/DashboardPage';
import WriterNotificationsPage from './pages/Writer/NotificationsPage';
import {
  WriterBlogsPage,
  DoctorBlogsPage,
  DoctorBlogCategoriesPage,
  WriterBlogFormPage,
  WriterEditBlogPage,
  WriterManageBlogCategoriesPage,
  WriterViewBlogPage,
} from './pages/Writer/Blogs';
import HerPhasesAnalyticsPage from "./pages/MasterAdmin/HerPhasesAnalyticsPage";

const App: React.FC = () => {
  return (
    <MantineProvider>
    <ThemeProvider>
      <AuthProvider>
        <Toaster position="top-right" />
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/" element={<Navigate to="/master-admin" replace />} />
                <Route path="/master-admin" element={<DashboardPage />} />
                <Route
                  path="/master-admin/operations/manual-refund-cases"
                  element={<VendorManualRefundCasesPage />}
                />
                <Route
                  path="/master-admin/operations/order-ledger/:orderId"
                  element={<MaOrderLedgerPage />}
                />
                <Route path="/vendors" element={<VendorsPage />} />
                <Route path="/vendors/onboarding/add/clinic" element={<DoctorClinicVendorForm />} />
                <Route path="/vendors/onboarding/add/ambulance" element={<AmbulanceVendorForm />} />
                <Route path="/vendors/edit/hospital/:vendorId" element={<AddHospitalVendorForm />} />
                <Route path="/vendors/edit/ambulance/:vendorId" element={<AmbulanceVendorForm />} />
                <Route path="/vendors/edit/clinic/:vendorId" element={<DoctorClinicVendorForm />} />
                <Route path="/vendors/edit/medical-store/:vendorId" element={<MedicalStoreVendorForm />} />
                <Route path="/vendors/edit/blood-bank/:vendorId" element={<BloodBankVendorForm />} />
                <Route path="/vendors/edit/diagnostic-center/:vendorId" element={<DiagnosticCenterVendorForm />} />
                <Route path="/vendors/edit/product-partner/:vendorId" element={<ProductPartnerVendorForm />} />
                <Route path="/vendors/hospital/:vendorId" element={<HospitalVendorDashboard />} />
                <Route path="/vendors/ambulance/:vendorId" element={<AmbulanceVendorDashboard />} />
                <Route path="/vendors/ambulance/:vendorId/details" element={<AmbulanceVendorDetailsPage />} />
                <Route path="/vendors/ambulance/:vendorId/pricing" element={<AmbulanceVendorPricingPage />} />
                <Route path="/vendors/ambulance/:vendorId/service-areas" element={<AmbulanceVendorServiceAreasPage />} />
                <Route path="/vendors/ambulance/:vendorId/fleet" element={<AmbulanceVendorFleetPage />} />
                <Route path="/vendors/ambulance/:vendorId/booking/:bookingId" element={<AmbulanceBookingDetailPage />} />
                <Route path="/vendors/medical-store/:vendorId" element={<MedicalStoreVendorDashboard />} />
                <Route path="/vendors/medical-store/:vendorId/details" element={<MedicalStoreVendorDetailsPage />} />
                <Route path="/vendors/medical-store/:vendorId/order/:orderId" element={<MedicalStoreMedicineOrderDetailPage />} />
                <Route path="/vendors/blood-bank/:vendorId" element={<BloodBankVendorDashboard />} />
                <Route path="/vendors/doctor-clinic/:vendorId" element={<DoctorClinicVendorDashboard />} />
                <Route path="/vendors/doctor-clinic/:vendorId/details" element={<DoctorClinicVendorDetailsPage />} />
                <Route path="/vendors/doctor clinic/:vendorId/details" element={<DoctorClinicVendorDetailsPage />} />
                <Route path="/vendors/doctor%20clinic/:vendorId/details" element={<DoctorClinicVendorDetailsPage />} />
                <Route path="/vendors/doctor-clinic/:vendorId/timeslots" element={<DoctorClinicVendorTimeslotsPage />} />
                <Route path="/vendors/diagnostic-center/:vendorId" element={<DiagnosticCenterVendorDashboard />} />
                <Route path="/vendors/product/:vendorId" element={<ProductVendorDashboard />} />
                <Route
                  path="/vendors/:vendorKind/:vendorId/login-activity"
                  element={<VendorLoginActivityPage />}
                />
                <Route
                  path="/vendors/:vendorKind/:vendorId/event-timeline"
                  element={<VendorEventTimelinePage />}
                />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users/:userId" element={<UserAnalyticsPage />} />
                <Route path="/users/:userId/sessions/:sessionId" element={<SessionDetailPage />} />
                <Route path="/employees" element={<EmployeesPage />} />
                <Route path="/employees/member/:id" element={<TeamMemberAccessPage />} />
                <Route path="/employees/sales-executive/:id" element={<SalesExecutiveDashboard />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/insights/analytics-dashboard" element={<DailyAnalyticsDashboardPage />} />
                <Route path="/insights/her-phases-analytics" element={<HerPhasesAnalyticsPage />} />
                <Route path="/insights/support-faqs" element={<SupportFaqsPage />} />
                <Route path="/insights/app-tracking" element={<AppTrackingInsightsPage />} />
                <Route path="/monitoring" element={<MonitoringPage />} />
                <Route path="/operations/production-dashboard" element={<OperationsDashboardPage />} />
                <Route path="/chatbot-intelligence" element={<ChatbotIntelligencePage />} />
                <Route path="/health-record-usage" element={<HealthRecordUsagePage />} />
                <Route path="/vendor-storage" element={<VendorStoragePage />} />
                <Route path="/billing/overview" element={<BillingOverviewPage />} />
                <Route path="/billing/services" element={<BillingServicesPage />} />
                <Route path="/billing/resources" element={<BillingResourcesPage />} />
                <Route path="/billing/history" element={<BillingHistoryPage />} />
                <Route path="/deliveries/borzo" element={<BorzoDeliveriesPage />} />
                <Route path="/in-progress-notify" element={<InProgressNotifyPage />} />
                <Route path="/ambulance-off-hours-demand" element={<AmbulanceOffHoursAnalyticsPage />} />
                <Route path="/ambulance-service-areas" element={<AmbulanceServiceAreaComparePage />} />
                <Route path="/operations/exotel-calling/*" element={<CommunicationsHubPage />} />
                <Route path="/operations/communications/*" element={<LegacyCommunicationsRedirect />} />
                <Route path="/operations/exotel-settings" element={<Navigate to="/operations/exotel-calling/settings" replace />} />
                <Route path="/insights/call-routing" element={<Navigate to="/operations/exotel-calling/activity" replace />} />
                <Route path="/feedbacks" element={<FeedbacksPage />} />
                <Route path="/grievances" element={<GrievancesPage />} />
                <Route path="/grievances/:grievanceId/policy/vendor" element={<GrievanceVendorPolicyPage />} />
                <Route path="/grievances/:grievanceId/policy/user" element={<GrievanceUserPolicyPage />} />
                <Route path="/grievances/:grievanceId/resolve" element={<GrievanceResolvePage />} />
                <Route path="/app-version-control" element={<AppVersionControlPage />} />
                <Route path="/app-version-control/notifications" element={<AppUpdateNotificationHistoryPage />} />
                <Route path="/vendor-form-catalog" element={<VendorReferenceDataPage />} />
                <Route path="/vendor-profile-updates" element={<VendorProfileUpdatesPage />} />
                <Route
                  path="/product/vendor-reference-data"
                  element={<Navigate to="/vendor-form-catalog" replace />}
                />
                <Route path="/request-queue" element={<PrescriptionQueuePage />} />
                <Route path="/ambulance-bookings" element={<MasterAdminAmbulanceBookingsPage />} />
                <Route path="/request-queue/ambulance/:bookingId/track" element={<AmbulanceQueueTrackingPage />} />
                <Route path="/push-notifications/*" element={<PushNotificationsPage />} />
                <Route path="/operations/marketing-emails" element={<MarketingEmailsPage />} />
                <Route path="/operations/whatsapp/*" element={<WhatsAppHubPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/operations/vendor-commission-management" element={<VendorCommissionManagementPage />} />
                <Route path="/operations/booking-offers" element={<BookingOffersPage />} />
                <Route path="/operations/membership/*" element={<MembershipManagementPage />} />
                <Route path="/operations/deep-links" element={<DeepLinksManagementPage />} />
                <Route path="/operations/media-management" element={<MediaManagementPage />} />
                <Route path="/operations/vendor-policy-queries" element={<VendorPolicyQueriesPage />} />
                <Route path="/operations/vendor-contact-queries" element={<VendorContactQueriesPage />} />
                <Route path="/operations/legal-policies/new" element={<LegalPolicyCreatePage />} />
                <Route path="/operations/legal-policies/:id/edit" element={<LegalPolicyEditPage />} />
                <Route
                  path="/operations/legal-policies/:id/acceptances"
                  element={<LegalPolicyAcceptancesPage />}
                />
                <Route path="/operations/legal-policies" element={<LegalPoliciesManagementPage />} />
                <Route
                  path="/operations/instant-consultation/sections"
                  element={<Navigate to="/operations/instant-consultation/specialities" replace />}
                />
                <Route
                  path="/operations/instant-consultation/specialities"
                  element={<InstantConsultationSpecialitiesPage />}
                />
                <Route
                  path="/operations/instant-consultation/symptom-mappings"
                  element={<SymptomSpecialityMappingsPage />}
                />
                <Route
                  path="/operations/manual-refund-cases"
                  element={<Navigate to="/master-admin/operations/manual-refund-cases" replace />}
                />
                <Route path="/settings" element={<div className="p-8 text-center">Settings Page (Coming Soon)</div>} />
                <Route path="/help" element={<div className="p-8 text-center">Help & Support Page (Coming Soon)</div>} />
              </Route>

              {/* Writer routes */}
              <Route path="/writer" element={<WriterLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<WriterDashboardPage />} />
                <Route path="notifications" element={<WriterNotificationsPage />} />
                <Route path="blogs" element={<WriterBlogsPage />} />
                <Route path="doctor-blogs" element={<DoctorBlogsPage />} />
                <Route path="doctor-blog-categories" element={<DoctorBlogCategoriesPage />} />
                <Route path="blogs/categories" element={<WriterManageBlogCategoriesPage />} />
                <Route path="blogs/create" element={<WriterBlogFormPage />} />
                <Route path="blogs/view/:id" element={<WriterViewBlogPage />} />
                <Route path="blogs/edit/:id" element={<WriterEditBlogPage />} />
                <Route path="awareness" element={<AwarenessListPage />} />
                <Route path="awareness/create" element={<AwarenessFormPage />} />
                <Route path="awareness/edit/:event_id" element={<AwarenessFormPage />} />
                <Route path="awareness/sections/:event_id" element={<AwarenessSectionsPage />} />
                <Route path="awareness/view/:event_id" element={<AwarenessViewPage />} />
              </Route>

              {/* Marketing routes */}
              <Route path="/marketing" element={<MarketingLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<MarketingDashboardPage />} />
                <Route path="emails" element={<MarketingEmailsPage />} />
                <Route path="whatsapp/*" element={<WhatsAppHubPage />} />
              </Route>

              {/* Sales Executive routes */}
              <Route path="/sales" element={<SalesExecutiveLayout />}>
                <Route path="dashboard" element={<SalesExecutiveDashboardPage />} />
                <Route path="vendor-onboarding" element={<SalesExecutiveVendorOnboardingPage />} />
                <Route path="vendor-onboarding/add" element={<SalesExecutiveAddVendorPage />} />
                <Route path="vendor-onboarding/add/hospital" element={<AddHospitalVendorForm />} />
                <Route path="vendor-onboarding/add/ambulance" element={<AmbulanceVendorForm />} />
                <Route path="vendor-onboarding/add/clinic" element={<DoctorClinicVendorForm />} />
                <Route path="vendor-onboarding/add/medical-store" element={<MedicalStoreVendorForm />} />
                <Route path="vendor-onboarding/add/blood-bank" element={<BloodBankVendorForm />} />
                <Route path="vendor-onboarding/add/diagnostic-center" element={<DiagnosticCenterVendorForm />} />
                <Route path="vendor-onboarding/add/product-partner" element={<ProductPartnerVendorForm />} />
                
                {/* Edit vendor routes */}
                <Route path="vendor-onboarding/edit/hospital/:vendorId" element={<AddHospitalVendorForm />} />
                <Route path="vendor-onboarding/edit/ambulance/:vendorId" element={<AmbulanceVendorForm />} />
                <Route path="vendor-onboarding/edit/clinic/:vendorId" element={<DoctorClinicVendorForm />} />
                <Route path="vendor-onboarding/edit/medical-store/:vendorId" element={<MedicalStoreVendorForm />} />
                <Route path="vendor-onboarding/edit/blood-bank/:vendorId" element={<BloodBankVendorForm />} />
                <Route path="vendor-onboarding/edit/diagnostic-center/:vendorId" element={<DiagnosticCenterVendorForm />} />
                <Route path="vendor-onboarding/edit/product-partner/:vendorId" element={<ProductPartnerVendorForm />} />
                {/* Add more sales executive pages here */}
              </Route>
              {/* Accountant routes */}
              <Route path="/accountant" element={<AccountantLayout />}>
                <Route path="dashboard" element={<AccountantDashboardPage />} />
                <Route path="settlements" element={<VendorSettlementsPage />} />
                <Route path="settlements/:vendorId" element={<VendorLedgerDetailsPage />} />
                <Route path="ledger" element={<LedgerPage />} />
                <Route path="ledger/customer" element={<CustomerLedgerPage />} />
                <Route path="ledger/vendor/medicine" element={<VendorLedgerMedicinePage />} />
                <Route path="ledger/vendor/ambulance" element={<VendorLedgerAmbulancePage />} />
                <Route path="ledger/vendor/doctor" element={<VendorLedgerDoctorPage />} />
                <Route path="ledger/vendor" element={<VendorLedgerPage />} />
                <Route path="ledger/delivery-partner" element={<DeliveryPartnerLedgerPage />} />
                <Route path="ledger/razorpay" element={<RazorpayLedgerPage />} />
                <Route path="ledger/bank" element={<BankAccountLedgerPage />} />
                <Route path="ledger/commission" element={<CommissionLedgerPage />} />
                <Route path="ledger/profit-loss" element={<ProfitLossLedgerPage />} />
                <Route path="ledger/gst" element={<GSTLedgerPage />} />
                <Route path="ledger/order/:orderId" element={<OrderLedgerPage />} />
                <Route path="manual-refund-cases" element={<VendorManualRefundCasesPage />} />
                <Route path="reports" element={<AccountantReportsPage />} />
                <Route path="audit" element={<AuditLogsPage />} />
                <Route path="settings" element={<div className="p-8 text-center">Accountant Settings Page (Coming Soon)</div>} />
                <Route path="help" element={<div className="p-8 text-center">Accountant Help & Support Page (Coming Soon)</div>} />
              </Route>
            </Route>
            
            {/* Redirect any unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
    </MantineProvider>
  );
};

export default App;
